<div
    *ngIf="showInternalVideo"
    class="w-full relative overflow-hidden bg-gray-900 rounded-lg"
    [ngStyle]="{
        'aspect-ratio': mobileMode ? component.mobileAspectRatio ?? '16/9' : component.aspectRatio ?? '16/9'
    }">

    <!-- Control Bar -->
    <div class="w-full h-14 flex gap-4 justify-end absolute p-4 top-0 right-0 bg-gradient-to-b from-black/60 to-transparent z-20" *ngIf="!loading && (subtitles.length || component.playlist && playlist.length || playing || paused)">
        <button
            role="button"
            type="button"
            aria-label="Toggle subtitles"
            class="w-8 h-8 cursor-pointer text-white hover:text-gray-200 transition-colors duration-200 rounded-md hover:bg-white/10 flex items-center justify-center"
            *ngIf="subtitles.length"
            (click)="toggleSubtitles()"
            aria-label="Toggle Subtitles">
            <svg height="20" viewBox="-21 -91 682.66669 682" width="20" xmlns="http://www.w3.org/2000/svg" fill="currentColor"><path d="m565 495.667969h-490c-41.359375 0-75-33.644531-75-75v-350c0-41.359375 33.640625-75 75-75h490c41.359375 0 75 33.640625 75 75v350c0 41.355469-33.640625 75-75 75zm-490-450c-13.785156 0-25 11.214843-25 25v350c0 13.78125 11.214844 25 25 25h490c13.785156 0 25-11.21875 25-25v-350c0-13.785157-11.214844-25-25-25zm170 237.5v2.5c0 26.191406-21.308594 47.5-47.5 47.5s-47.5-21.308594-47.5-47.5v-80c0-26.191407 21.308594-47.5 47.5-47.5s47.5 21.308593 47.5 47.5v2.5h50v-2.5c0-53.761719-43.734375-97.5-97.5-97.5s-97.5 43.738281-97.5 97.5v80c0 53.757812 43.734375 97.5 97.5 97.5s97.5-43.742188 97.5-97.5v-2.5zm245 0v2.5c0 26.191406-21.308594 47.5-47.5 47.5s-47.5-21.308594-47.5-47.5v-80c0-26.191407 21.308594-47.5 47.5-47.5s47.5 21.308593 47.5 47.5v2.5h50v-2.5c0-53.761719-43.734375-97.5-97.5-97.5s-97.5 43.738281-97.5 97.5v80c0 53.757812 43.734375 97.5 97.5 97.5s97.5-43.742188 97.5-97.5v-2.5zm0 0"></path></svg>
        </button>
        <button
            role="button"
            class="w-8 h-8 cursor-pointer text-white hover:text-gray-200 transition-colors duration-200 rounded-md hover:bg-white/10 flex items-center justify-center"
            *ngIf="component.playlist && playlist.length"
            (click)="togglePlaylist()"
            aria-label="Show Playlist"
            matTooltip="Show Playlist">
            <svg height="20" viewBox="0 0 512 512" width="20" xmlns="http://www.w3.org/2000/svg" fill="currentColor"><path d="m280.593 449.83a16 16 0 0 1 -16 16h-248.593a16 16 0 0 1 0-32h248.593a16 16 0 0 1 16 16zm-16-151.538h-248.593a16 16 0 0 0 0 32h248.593a16 16 0 0 0 0-32zm-248.593-239.076h480a16 16 0 0 0 0-32h-480a16 16 0 0 0 0 32zm496 322.845a16 16 0 0 1 -7.773 13.723l-144.673 86.724a16 16 0 0 1 -24.226-13.724v-173.447a16 16 0 0 1 24.226-13.724l144.672 86.724a16 16 0 0 1 7.774 13.724zm-47.12 0-97.552-58.478v116.956zm31.12-219.307h-480a16 16 0 0 0 0 32h480a16 16 0 0 0 0-32z"></path></svg>
        </button>
    </div>

    <!-- Play Button Overlay -->
    <div class="absolute inset-0 w-full h-full p-8 flex flex-col gap-6 justify-center items-center text-white bg-black/30 hover:bg-black/40 transition-all duration-300 z-10 group" *ngIf="!component.autoplay && !loading && !playing && !paused" role="dialog">
        <button
            name="play"
            type="button"
            role="button"
            aria-label="Play Video"
            class="flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm cursor-pointer w-20 h-20 group-hover:w-24 group-hover:h-24 group-hover:bg-white/30 transition-all duration-300 hover:scale-110"
            (click)="togglePlay()">
            <span class="mat-icon text-white text-4xl group-hover:text-5xl transition-all duration-300">play_arrow</span>
        </button>
        <span *ngIf="component.caption" class="max-w-xl text-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-lg text-white font-medium drop-shadow-lg">{{component.caption}}</span>

        <!-- Playlist Button in Overlay -->
        <button
            *ngIf="playlist.length"
            role="button"
            class="absolute top-4 right-4 w-10 h-10 cursor-pointer text-white hover:text-gray-200 transition-colors duration-200 rounded-full bg-black/40 hover:bg-black/60 flex items-center justify-center backdrop-blur-sm"
            (click)="togglePlaylist()"
            aria-label="Show Playlist"
            matTooltip="Show Playlist">
            <svg height="20" viewBox="0 0 512 512" width="20" xmlns="http://www.w3.org/2000/svg" fill="currentColor"><path d="m280.593 449.83a16 16 0 0 1 -16 16h-248.593a16 16 0 0 1 0-32h248.593a16 16 0 0 1 16 16zm-16-151.538h-248.593a16 16 0 0 0 0 32h248.593a16 16 0 0 0 0-32zm-248.593-239.076h480a16 16 0 0 0 0-32h-480a16 16 0 0 0 0 32zm496 322.845a16 16 0 0 1 -7.773 13.723l-144.673 86.724a16 16 0 0 1 -24.226-13.724v-173.447a16 16 0 0 1 24.226-13.724l144.672 86.724a16 16 0 0 1 7.774 13.724zm-47.12 0-97.552-58.478v116.956zm31.12-219.307h-480a16 16 0 0 0 0 32h480a16 16 0 0 0 0-32z"></path></svg>
        </button>
    </div>

    <!-- Loading State -->
    <div *ngIf="loading" class="absolute inset-0 w-full h-full bg-gray-900 z-30 flex items-center justify-center">
        <div class="flex flex-col items-center gap-4">
            <div role="status" class="relative">
                <div class="w-16 h-16 border-4 border-gray-600 border-t-white rounded-full animate-spin"></div>
            </div>
            <p class="text-white text-sm font-medium">Loading video...</p>
        </div>
    </div>

    <!-- Playlist Sidebar -->
    <div class="absolute bg-white/95 backdrop-blur-sm p-6 top-0 md:w-80 w-full h-full z-30 transition-all duration-300 ease-in-out shadow-2xl" [ngClass]="{
        'right-0': showPlaylist,
        'md:right-[-320px] right-[100%]': !showPlaylist,
    }">
        <div class="flex items-center justify-between mb-6">
            <h3 class="text-lg font-semibold text-gray-900">Playlist</h3>
            <button
                type="button"
                role="button"
                aria-label="Close Playlist"
                (click)="togglePlaylist()"
                class="rounded-full p-2 bg-gray-100 text-gray-400 hover:text-gray-600 hover:bg-gray-200 transition-colors duration-200">
                <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>
        <div class="space-y-2 max-h-[calc(100%-80px)] overflow-y-auto">
            <div class="flex gap-3 p-3 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors duration-200"
                 [ngClass]="{'bg-blue-50 border border-blue-200': videoData?._id === originVideo?._id}"
                 (click)="playPlaylistVideo(originVideo)">
                <img class="h-12 w-20 flex-none rounded-md bg-gray-100 object-cover" [src]="originVideo?.thumbnail" [alt]="originVideo?.name">
                <div class="min-w-0 flex-1">
                    <p class="text-sm font-medium text-gray-900 truncate">{{originVideo?.name}}</p>
                    <p class="text-xs text-gray-500 mt-1">{{originVideo?.dynamoData?.srcMediainfo?.container?.duration | date:'mm:ss'}}</p>
                    <span *ngIf="videoData?._id === originVideo?._id" class="inline-block mt-1 px-2 py-1 text-xs bg-blue-100 text-blue-800 rounded-full">Playing</span>
                </div>
            </div>
            <div *ngFor="let v of playlist"
                 class="flex gap-3 p-3 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors duration-200"
                 [ngClass]="{'bg-blue-50 border border-blue-200': videoData?._id === v?._id}"
                 (click)="playPlaylistVideo(v)">
                <img class="h-12 w-20 flex-none rounded-md bg-gray-100 object-cover" [src]="v.thumbnail" [alt]="v.name">
                <div class="min-w-0 flex-1">
                    <p class="text-sm font-medium text-gray-900 truncate">{{v?.name}}</p>
                    <p class="text-xs text-gray-500 mt-1">{{v.dynamoData?.srcMediainfo?.container?.duration | date:'mm:ss'}}</p>
                    <span *ngIf="videoData?._id === v?._id" class="inline-block mt-1 px-2 py-1 text-xs bg-blue-100 text-blue-800 rounded-full">Playing</span>
                </div>
            </div>
        </div>
    </div>

    <!-- Video Element -->
    <video class="w-full h-full object-cover" #videoElement crossorigin loop playsinline></video>
</div>

<div *ngIf="showLoomVideo" #loom class="w-full rounded-lg overflow-hidden"></div>

<div *ngIf="showYouTubeVideo" #youtube class="w-full relative overflow-hidden bg-gray-900 rounded-lg" [ngStyle]="{
    'aspect-ratio': mobileMode ? component.mobileAspectRatio ?? '16/9' : component.aspectRatio ?? '16/9'
}"></div>
